import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger, Panel, PanelGroup } from "react-bootstrap";
import { toast } from 'react-toastify';
import Select from 'react-select';

import CustomModal from "../../components/Modal/CustomModal";
import { CustomCard } from "../../components/Card/CustomCard";
import ModalReports from '../../components/Reportes/ModalReports';
import PlanillaBeca from '../../components/Reportes/PlanillaBeca';

import MensajeRetraso from "../../shared/MensajeRetraso";

import { ConsultaDeuda } from '../../funciones/EstCuentaFunction';
import { ConsultInscripcion } from '../../funciones/ConstanciaFunction';
import { ConsultBecas, ConsultDataBeca, ConsultDataBecas, BecasSolicitadas, SolicitarBeca, ConsultaRequisitos, ConsultBecado,
        ConsultCarrera, ChkDatos, ConsultDatosEst } from '../../funciones/SolicitudesFunction';

import BecaAcademicos from "./BecaAcademicos";
import BecaSalud from "./BecaSalud";
import BecaSocioEc from "./BecaSocioEc";
import BecaFamilia1 from "./BecaFamilia1";
import BecaFamilia2 from "./BecaFamilia2";
import BecaFamilia3 from "./BecaFamilia3";
import BecaEstSocioEc from "./BecaEstSocioEc";

let deudaTSolic = "";
let statusBtn = 0;
let statusBtn2 = "";
let statusBeca = 0;
let Becado = false;
let UcAp = "";
let fecha = new Date();
let ctrlE = 0;
let BecaDat = "";
class BecaEst extends Component {
    state = {
        status: {
            icon: "fa fa-spinner fa-spin",
            text: "Verificando, espera por favor",
            class: "custom-alert-info",
            styles:{fontSize:12, position:"absolute", top: 4}
        },
        histBecas: [],
        deudaT: "",
        datosEst:"",
        preloader: {
            icono: "fa fa-spinner fa-spin",
            text: "Buscando Solicitudes"
        },
        button: {
            icon: "fa fa-life-saver",
            text: "Solicitar Beca"
        },
        boton2: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        becaSelect: { value: 1, label: 'Beca Completa' },
        openW: false,
        iconChevron: "fa fa-chevron-down",
        btnDown: true,
        iconChevronD: "fa fa-chevron-up",
        btnDownD: false,
        activeKeyD: 1,
        listaRequisitos: [],
        preloaderReq: {
            icono: "fa fa-spinner fa-spin",
            text: "Buscando Lista de Requisitos"
        },
        /* ------------------------------------------------------------------ */
        datosBecaAcademicos: [{
            institucion: { text: "", errMess: "Selecciona la Institución de Educación Secundaria" },
            paisSelect: { value: "", label: '- Selecciona un País -', errMess: "Selecciona el País de la Institución Secundaria" },
            estadoSelect: { value: "", label: '- Selecciona un Estado -', errMess: "Selecciona el Estado de la Institución Secundaria" },
            ciudad: { text: "", errMess: "" },
            caracterSelect: { value: "PRI", label: 'PRIVADO', errMess: "" },
            mencionSelect: { value: "", label: '- Selecciona -', errMess: "Selecciona la Mención de Educacion Secundaria" },
            fecha: { text: fecha, errMess: "Selecciona la Fecha de Egreso de Educación Secundaria" },
            rusnies:  { text: "", errMess: "Indica el número de la planilla RUSNIES" },
        }],
        datosBecaSalud: [{
            chkSi: { value: false, errMess: "" },
            chkNo: { value: true, errMess: "" },
            chkFis: { value: false, errMess: "" },
            chkPsi: { value: false, errMess: "" },
            chkSen: { value: false, errMess: "" },
            enfermedad:  { text: "", errMess: "" },
            enDis: { value: true, errMess: "" },
            discapacidad:  { text: "", errMess: "" },
            diDis: { value: true, errMess: "" },
        }],
        datosBecaSocioEc: [{
            nombre1: { text: "", errMess: "El campo Primer Nombre del representante es obligatorio" },
            nombre2: { text: "", errMess: "" },
            cedula: { text: "", errMess: "El campo Cédula del representante es obligatorio" },
            apellido1: { text: "", errMess: "El campo Primer Apellido del representante es obligatorio" },
            apellido2: { text: "", errMess: "" },
            parentesco: { text: "", errMess: "El campo Parentesco del Representante es obligatorio" },
            estadoSelect: { value: "", label: '- Selecciona un Estado -', errMess: "Selecciona el Estado de la Dirección de Habitación" },
            municipioSelect: { value: "", label: '- Selecciona un Municipio -', errMess: "Selecciona el Municipio de la Dirección de Habitación" },
            parroquiaSelect: { value: "", label: '- Selecciona una Parroquia -', errMess: "Selecciona la Parroquia de la Dirección de Habitación" },
            ciudad: { text: "", errMess: "" },
            sector: { text: "", errMess: "El campo Urbanización de Dirección de Habitación es obligatorio" },
            casa: { text: "", errMess: "El campo Edificio de Dirección de Habitación es obligatorio" },
            calle: { text: "", errMess: "El campo Avenida de Dirección de Habitación es obligatorio" },
            chkPr: { value: true, errMess: "" },
            chkAl: { value: false, errMess: "" },
            tlf1: { text: "", errMess: "" },
            tlf2: { text: "", errMess: "" },
            email: { text: "", errMess: "El campo Email es obligatorio" },
            tlf3: { text: "", errMess: "" },
            instruccion: { text: "", errMess: "El campo Grado de Instrucción es obligatorio" },
            ocupacion: { text: "", errMess: "El campo Ocupación es obligatorio" },
            trabajo: { text: "", errMess: "El campo Lugar de Trabajo es obligatorio" },
            direccionT: { text: "", errMess: "El campo Dirección de Trabajo es obligatorio" },
            cargo: { text: "", errMess: "El campo Cargo es obligatorio" },
        }],
        datosBecaFamilia1: [{
            chkAP: { value: true, errMess: "" },
            chkUP: { value: false, errMess: "" },
            chkCony: { value: false, errMess: "" },
            chkHer: { value: false, errMess: "" },
            chkNor: { value: true, errMess: "" },
            chkDis: { value: false, errMess: "" },
            nombre1: { text: "", errMess: "" },
            nombre2: { text: "", errMess: "" },
            cedula: { text: "", errMess: "" },
            apellido1: { text: "", errMess: "" },
            apellido2: { text: "", errMess: "" },
            tlf: { text: "", errMess: "" },
            instruccion: { text: "", errMess: "" },
            ocupacion: { text: "", errMess: "" },
            trabajo: { text: "", errMess: "" },
            cargo: { text: "", errMess: "" },
            direccion: { text: "", errMess: "" },
            tlf2: { text: "", errMess: "" },
        }],
        datosBecaFamilia2: [{
            familia: { value: [], errMess: "" },
            dependen: { text: "", errMess: "Debes indicar el número de personas que dependen del responsable económico" },
            trabajan: { text: "", errMess: "Debes indicar el número de miembros del grupo familiar que trabajan" },
        }],
        datosBecaFamilia3: [{
            infoIn: { value: [], errMess: "" },
            infoOut: { value: [], errMess: "" }
        }],
        datosBecaEstSocioEc: [{
            preg1Select: "",
            preg2Select: "",
            preg3Select: "",
            preg4Select: "",
        }],
        /* ----------------------------------------------------------------- */
        cantErrores: "",
        openWReport: false,

        /* ----------------------------------------------------------------- */
        data1: "",
        data2: "",
        dataPersonales: [],
        dataBeca: [],
        carrera: ""
        /* ----------------------------------------------------------------- */
    }

    componentDidMount = () => {
        ConsultBecas ((status) => {
            statusBeca = status;
        })

        ConsultDataBecas ((resp) => {
            BecaDat = resp
        })

        ConsultBecado ((resp) => {
            Becado = resp[0];
            UcAp = resp[1];
        })

        ConsultaDeuda ((resp) => {
            deudaTSolic = resp.deudaVencida
            this.setState({deudaT: resp.deudaVencida})
        })

        ConsultInscripcion ((resp) => {
            statusBtn = resp[3]
            statusBtn2 = resp[4]
            this.setState({
                status: resp[0],
                datosEst: resp[2]
            })
        })

        BecasSolicitadas ((resp) => {
            let pre = "";
            if (resp.length === 0){
                pre =  {
                    icono: "",
                    text: "No tienes solicitudes de becas"
                }
            }else{
                ConsultDatosEst ((resp) => {
                    this.setState({
                        dataPersonales: resp
                    })
                })

                ConsultDataBeca ((resp) => {
                    this.setState({
                        dataBeca: resp
                    })
                })

                ConsultCarrera ((resp) => {
                    this.setState({
                        carrera: resp
                    })
                })
                
            }

            let data = "";
            let data2 = false;
            for (let i in resp) {
                if (resp[i].status === 0) {
                    data = resp[i].tipo
                    data2 = true;
                }
            }

            this.setState({
                histBecas: resp,
                preloader: pre,
                data1: data,
                data2: data2,
            })
        })

        ConsultaRequisitos ((resp) => {
            let pre = "";
            if (resp.length === 0) pre =  {
                icono: "",
                text: "No existen requisitos registrados"
            }

            this.setState({
                listaRequisitos: resp,
                preloaderReq: pre
            })
        })
    }

    valorSelectBeca = (becaSelect) => {
        this.setState({
            becaSelect
        });
    }

    updaState = (campo, valor, campoR) => {
        let contenido = this.state[campoR];
        
        (contenido.length === 0) ? contenido.push({[campo]: valor}) : contenido[0][campo] = valor;

        this.setState({campoR: contenido})
    }

    cambiaIcon = () => {
        this.setState ({
            btnDown: !this.state.btnDown,
        }, () => {
            (this.state.btnDown === true) ? this.setState({iconChevron: "fa fa-chevron-down"}) : this.setState({iconChevron: "fa fa-chevron-up"})
        })
    }

    cambiaIconD = () => {
        this.setState ({
            btnDownD: !this.state.btnDownD,
        }, () => {
            (this.state.btnDownD === true) ? this.setState({
                iconChevronD: "fa fa-chevron-down",
                activeKeyD: 2
            }) : this.setState({
                iconChevronD: "fa fa-chevron-up",
                activeKeyD: 1
            })
        })
    }

    solicitarB = () => (e) => {
        if (this.state.boton2.disabled === true) return null;

        this.setState({
            boton2: {
                icon:"fa fa-spinner fa-spin",
                text: "Espera",
                disabled: true
            }
        }, () => {
            let { becaSelect, datosBecaAcademicos, datosBecaSalud, datosBecaSocioEc, datosBecaFamilia1,
                datosBecaFamilia2, datosBecaFamilia3, datosBecaEstSocioEc } = this.state;

            SolicitarBeca(becaSelect.value, datosBecaAcademicos, datosBecaSalud, datosBecaSocioEc, datosBecaFamilia1,
                datosBecaFamilia2, datosBecaFamilia3, datosBecaEstSocioEc, (resp) => {
                
                this.setState({
                    openW: false,
                },() => {
                    ConsultBecas ((status) => {
                        statusBeca = status;
                    })

                    ConsultDataBecas ((resp) => {
                        BecaDat = resp
                    })

                    ConsultDatosEst ((resp) => {
                        this.setState({
                            dataPersonales: resp
                        })
                    })
    
                    ConsultDataBeca ((resp) => {
                        this.setState({
                            dataBeca: resp
                        })
                    })

                    ConsultCarrera ((resp) => {
                        this.setState({
                            carrera: resp
                        })
                    })

                    ConsultInscripcion ((resp) => {
                        this.setState({
                            status: resp[0],
                            boton2: {
                                icon: "fa fa-check",
                                text: "Si",
                                disabled: false
                            }
                        })
                    })

                    BecasSolicitadas ((resp) => {
                        let pre = "";
                        if (resp.length === 0) pre =  {
                            icono: "",
                            text: "No tienes solicitudes de becas"
                        }

                        let data = "";
                        let data2 = false;
                        for (let i in resp) {
                            if (resp[i].status === 0) {
                                data = resp[i].tipo
                                data2 = true;
                            }
                        }

                        this.setState({
                            histBecas: resp,
                            preloader: pre,
                            data1: data,
                            data2: data2,
                        })
                    })
                    
                    toast.info("Solicitud de Beca completada. Puedes revisar el status de esta solicitud desde este módulo",{autoClose: 4000});    
                })
            })
        })
    }

    showModal = () => {
        let { boton2, becaSelect } = this.state;
        if (ctrlE !== 2) return null;

        let contenidoModal = () => (
            <React.Fragment>
                <div>¿Deseas optar para una <strong className="text-danger">{becaSelect.label}</strong>?</div>
                <div style={{fontSize:10}}>Esta opción no puede deshacerse y no podrás solicitar otra hasta que esta sea respondida</div>
                <div style={{fontSize:10}}><strong>Debes completar todos los requisitos del listado y llevarlos a Dirección</strong></div>
            </React.Fragment>
        )
        return (
            <CustomModal
                isopen =  {this.state.openW}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className= {boton2.icon}></i> {boton2.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className= "fa fa-times"></i> No</React.Fragment>}
                funcion1 = {this.solicitarB()}
                funcion2 = {() => {this.setState({openW: false})}}/>
        );
    }

    cantUc = () => {
        if (UcAp === "") return null;

        return (
            <React.Fragment>
                <div className="text-danger">Tu estado:</div>
                <div className="custom-alert-success" style={{padding: 9}}>
                    <i className="fa fa-handshake-o"></i> Actualmente estas becado con <strong> {UcAp} Unidad(es) de Crédito</strong>
                </div>
            </React.Fragment>
        )
    }

    respuestaChk = (resp) => {
        let mensaje = resp[0];
        let errores = resp[1];
        let nameErrores = resp[2]
        let contentErr = [];
        
        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                <div style={{maxHeight: "40vh", overflowY: "auto"}}>{contentErr}</div>
            </Popover>
        )

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.setState({ cantErrores:"" })
        }
        
        if (BecaDat === 1){
            ctrlE = 2;
            this.setState({openW: true})
        }else{
            if (mensaje[0].status === "error" && errores !== 0){
                ctrlE = 0;
                toast[mensaje[0].status](mensaje[0].mensaje,{autoClose: 4000});
                this.setState ({
                    cantErrores: <div style={{paddingTop:10, fontSize: 11}}>
                                    Se han encontrado {errores} error(es). Haz click <span>
                                    <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                        <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                                    </OverlayTrigger></span> para verlos
                                </div>
                })
            }else{
                ctrlE = 2;
                this.setState({openW: true})
            }
        }
    }

    solicitarBeca = () => {
        let { datosBecaAcademicos, datosBecaSalud, datosBecaSocioEc, datosBecaFamilia1,
            datosBecaFamilia2, datosBecaFamilia3, datosBecaEstSocioEc } = this.state;
        
        ChkDatos (datosBecaAcademicos[0], datosBecaSalud[0], datosBecaSocioEc[0], datosBecaFamilia1[0],
                    datosBecaFamilia2[0], datosBecaFamilia3[0], datosBecaEstSocioEc[0], (resp) => {this.respuestaChk(resp)})
    }

    modalReport = () => {
        if (this.state.openWReport === false) return null
        let { data1, data2, dataPersonales, dataBeca, carrera } = this.state;

        return (
            <ModalReports 
                reporte={<PlanillaBeca
                    data1 = {data1}
                    data2 = {data2}
                    personal = {dataPersonales}
                    data3 = {dataBeca}
                    carrera = {carrera.carrera_name}
                />}
                titulo="Impresión de Solicitud de Ayuda Económica"
                display= "block"
                cerrar = {() => {this.setState({openWReport:false})}}
            />
        )
    }

    botones = () => {
        let { button } = this.state;

        let btnPrint = () => {
            if (BecaDat === 1) return (
                <button className="btn btn-primary" onClick={() => { this.setState({openWReport:true })}} style={{borderWidth: 1}} title="Imprimir planilla de solicitud"><i className="fa fa-print"></i> Imprimir</button>
            )
        }

        if (deudaTSolic === "") return (
            <Col md ={12} className="custom-mt-10">
                <div className="text-danger" align = "center"><i className="fa fa-spinner fa-spin"></i> Buscando Información, espera</div>
            </Col>
        )
        
        if (deudaTSolic > 0) return (<MensajeRetraso />)

        switch (statusBtn) {
            case 0:
                if (statusBeca > 0 ) {
                    let contenido = (
                        <Popover bsSize="large" title="Importante" id="Inscrito">
                            <div className="custom-alert-danger" align="center">Tienes solicitudes abiertas</div>
                            <div align="justify" className="custom-mt-10">
                                Ya has hecho una petición de Beca, espera que su estatus cambie para poder realizar una nueva petición
                            </div>
                        </Popover>
                    )

                    return (
                        <div align="right">
                            <div className="btn-group" role="group">
                                {btnPrint()}
                                <OverlayTrigger trigger="focus" placement="right" overlay={contenido}>
                                    <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    )
                }else{
                    if (Becado === true) {
                        let contenidob = (
                            <Popover bsSize="large" title="Importante" id="Inscrito">
                                <div className="custom-alert-danger" align="center">No necesitas realizar este proceso</div>
                                <div align="justify" className="custom-mt-10">
                                    Ya tienes una solicitud de beca <strong className="text-success">APOBADA</strong>, por lo que no puedes realizar otra petición
                                </div>
                            </Popover>
                        )
    
                        return (
                            <div className="btn-group" role="group">
                                <OverlayTrigger trigger="focus" placement="right" overlay={contenidob}>
                                    <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                                </OverlayTrigger>
                            </div>
                        )
                    }
                    return (
                        <Row>
                            <Col md={6}><div className="text-danger">{ this.state.cantErrores }</div></Col>
                            <Col md={6} align="right">
                                <div className="btn-group">
                                    {btnPrint()}
                                    <button className="btn btn-primary" onClick = {this.solicitarBeca} style={{borderWidth: 1}}><i className={button.icon}></i> {button.text}</button>
                                </div>
                            </Col>
                        </Row>
                    )
                }
            case 1:
                let contenido1 = (
                    <Popover bsSize="large" id="Inscrito">
                        <div className="custom-alert-danger" align="center">No estas inscrito</div>
                        <div align="justify" className="custom-mt-10">
                            Para poder solicitar una beca primero debes formalizar tu inscripción
                        </div>
                    </Popover>
                )

                return (
                    <div className="btn-group" role="group">
                        <OverlayTrigger trigger="focus" placement="right" overlay={contenido1}>
                            <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                        </OverlayTrigger>
                    </div>
                )
            case 2:
                let contenido2 = (
                    <Popover bsSize="large" id="Inscrito">
                        <div className="custom-alert-danger" align="center">Importante</div>
                        <div align="justify" className="custom-mt-10">
                            Tu inscripción aun no está aprobada, espera que la aprueben para poder solicitar una beca
                        </div>
                    </Popover>
                )

                return (
                    <div className="btn-group" role="group">
                        <OverlayTrigger trigger="focus" placement="right" overlay={contenido2}>
                            <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                        </OverlayTrigger>
                    </div>
                )
            default:
                return (
                    <button className="btn btn-primary" style={{borderWidth: 1}} title="Presiona F5 para refrescar esta página"><i className="fa fa-times"></i> Error al Cargar</button>
                )
        }
    }

    contenido = () => {
        let { histBecas, preloader, becaSelect, activeKey, iconChevron, listaRequisitos, preloaderReq,
            iconChevronD, activeKeyD } = this.state;

        let { datosBecaAcademicos, datosBecaSalud, datosBecaSocioEc, datosBecaFamilia1,
            datosBecaFamilia2, datosBecaFamilia3, datosBecaEstSocioEc } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const becas = [
            { value: 1, label: 'Beca Completa' },
            { value: 2, label: 'Media Beca' },
            { value: 3, label: 'Beca Trabajo' },
        ];
        
        let solicitudes = () => {
            if (histBecas.length === 0) return (
                <tr>
                    <td width="100%" colSpan={3} style={styles} align="center"><i className={preloader.icono}></i> {preloader.text}</td>
                </tr>
            )

            let status = (status) => {
                switch (parseInt(status)) {
                    case 0:
                        return <div className="text-warning"><i className="fa fa-clock-o"></i> PENDIENTE </div>;
                    case 1:
                        return <div className="text-success"><i className="fa fa-check-circle"></i> APROBADA</div>;
                    case 2:
                        return <div className="text-danger"><i className="fa fa-times-circle"></i> NO APROBADA</div>;
                    default:
                        return 'PENDIENTE';
                }
            }

            let tipoBeca = (tipo) => {
                switch (tipo) {
                    case "1":
                        return "BECA COMPLETA";
                    case "2":
                        return "MEDIA BECA";
                    case "3":
                        return "BECA TRABAJO";
                    default:
                        return 'ERROR';
                }
            }

            return(
                histBecas.map(option => (
                    <tr key={option.id}>
                        <td style={styles}>{`SOLICITUD DE ${tipoBeca(option.tipo)} N° - [${option.id}]`}</td>
                        <td align="center" style={styles}>{option.fecha}</td>
                        <td align="center" style={styles}>{status(option.status)}</td>
                    </tr>
                ))
            )
        }

        let requisitosBeca = () => {
            if (listaRequisitos.length === 0) return (
                <tr>
                    <td style={styles} align="center"><i className={preloaderReq.icono}></i> {preloaderReq.text}</td>
                </tr>
            )
            
            let num = 0;
            return (
                listaRequisitos.map(option => {
                    num++;
                    return (
                        <tr key={option.id}>
                            <td width="20px" align="center" style={styles}>{num}</td>
                            <td style={styles}>{option.requisito}</td>
                        </tr>
                    )
                })
            )
        }

        let datosBeca = () => {
            switch (BecaDat){
                case "": return(
                    <div align="center">
                        <i className="fa fa-spinner fa-spin"></i> Espera que termine de cargar la información
                    </div>
                )
                case 0: return(
                    <React.Fragment>
                        <div className="text-danger" align="left"><strong>Los campos marcados con asterísco (*) son obligatorios</strong></div>
                        <BecaAcademicos funcion = {(campo, valor, campoR) => {this.updaState(campo, valor, campoR)}} datos={datosBecaAcademicos[0]}/>
                        <BecaSalud funcion = {(campo, valor, campoR) => {this.updaState(campo, valor, campoR)}} datos = {datosBecaSalud[0]}/>
                        <BecaSocioEc funcion = {(campo, valor, campoR) => {this.updaState(campo, valor, campoR)}} datos = {datosBecaSocioEc[0]}/>
                        <BecaFamilia1 funcion = {(campo, valor, campoR) => {this.updaState(campo, valor, campoR)}} datos = {datosBecaFamilia1[0]}/>
                        <BecaFamilia2 funcion = {(campo, valor, campoR) => {this.updaState(campo, valor, campoR)}} datos = {datosBecaFamilia2[0]}/>
                        <BecaFamilia3 funcion = {(campo, valor, campoR) => {this.updaState(campo, valor, campoR)}} datos = {datosBecaFamilia3[0]}/>
                        <BecaEstSocioEc funcion = {(campo, valor, campoR) => {this.updaState(campo, valor, campoR)}} datos = {datosBecaEstSocioEc[0]}/>
                    </React.Fragment>
                )
                default: return (
                    <div align="center">
                        Ya has solicitado becas previamente y no necesitas llenar nuevamente esta información
                    </div>
                )
            }
        }

        return (
            <Row>
                <Col md={12}>
                    <div>
                        <PanelGroup accordion activeKey={activeKey} className="custom-alert-danger" id="requisitos">
                            <Panel eventKey={1} key ={1} style={{marginBottom:5, marginTop: 5}}>
                                <Panel.Heading>
                                    <Panel.Title toggle className="text-danger" onClick={this.cambiaIcon}>
                                        <Row>
                                            <Col md={10} style={{fontSize: 12}}>
                                                <strong>Requisitos para optar a una Beca</strong>
                                                <spam style={{fontSize: 10}}> (Haz click aqui para ver)</spam>
                                            </Col>
                                            <Col md={2} align="right">
                                                <i className={iconChevron}></i>
                                            </Col>
                                        </Row>
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                                    <div className="table-responsive">
                                        <Table striped hover bordered>
                                            <tbody>
                                                <tr>
                                                    <td colSpan={2} width="100%" align="center" style={styles}><strong>Lista de Requisitos</strong></td>
                                                </tr>
                                                {requisitosBeca()}
                                            </tbody>    
                                        </Table>
                                    </div>
                                </Panel.Body>
                            </Panel>
                        </PanelGroup>
                    </div>
                </Col>
                <Col md ={12} className="custom-mt-10"><div className="custom-alert-info" style={{padding:5}}>Mi historial de solicitudes de becas</div></Col>
                <Col md ={8} className="custom-mt-10">
                    {this.cantUc()}
                </Col>
                <Col md ={4} className="custom-mt-10">
                    <div className="text-danger" align="right">Selecciona el Tipo de Beca</div>
                    <Select
                        isSearchable ={true}
                        value={becaSelect}
                        onChange={this.valorSelectBeca}
                        options={becas}
                    />
                </Col>
                <Col md ={12} className="custom-mt-10">
                    <div className="table-responsive">
                        <Table striped hover bordered style={{marginBottom: "0px !important"}}>
                            <tbody>
                                <tr>
                                    <td width="50%" style={styles}>Solicitud</td>
                                    <td width="25%" align="center" style={styles}>Fecha</td>
                                    <td width="25%" align="center" style={styles}>Estatus</td>
                                </tr>
                                {solicitudes()}
                            </tbody>    
                        </Table>
                    </div>
                </Col>
                <Col md ={12} className="custom-mt-10">
                    <PanelGroup accordion activeKey={activeKeyD} className="custom-alert-info" id="formulario">
                        <Panel eventKey={1} key ={1} style={{marginBottom:5, marginTop: 5}}>
                            <Panel.Heading>
                                <Panel.Title toggle className="text-primary" onClick={this.cambiaIconD}>
                                    <Row>
                                        <Col md={10} style={{fontSize: 12}}>
                                            <strong>Formulario de Registro de Beca</strong>
                                        </Col>
                                        <Col md={2} align="right">
                                            <i className={iconChevronD}></i>
                                        </Col>
                                    </Row>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                                {datosBeca()}
                            </Panel.Body>
                        </Panel>
                    </PanelGroup>
                </Col>
                <Col md={12} className="custom-mt-20">
                    {this.botones()}
                </Col>
            </Row>
        )
    }

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12} align="justify">
                    En esta sección puedes postular tu solicitud de beca estudiantil. Para ello simplemente debes elegir entre los tipos de becas disponibles y presionar el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-life-saver"></i> Solicitar Beca</button>
                </Col>
                <Col md={12} className="custom-mt-10" align="justify">
                    Es importante que para optar a una beca leas y cumplas con los requisitos que se muestran en esta sección, de lo contrario tu petición será rechazada.
                </Col>
                <Col md={12} className="custom-mt-10" align="justify">
                    Al solicitar la beca podrás ver el estatus de dicha solicitud:
                </Col>
                <Col md={12} className="custom-mt-10">
                    <span className="text-warning" style={{fontSize: 10}}><i className="fa fa-clock-o"></i>PENDIENTE</span>
                </Col>
                <Col md={12} style={{fontSize: 11}} align="justify">
                    Indica que la solicitud está en proceso. Se está revisando tu petición. Mientras este proceso esta en este estado, no podrás realizar otra solicitud de beca
                </Col>
                <Col md={12} className="custom-mt-10">
                    <span className="text-success" style={{fontSize: 10}}><i className="fa fa-check"></i>APROBADA</span>
                </Col>
                <Col md={12} style={{fontSize: 11}} align="justify">
                    Indica que tu petición de Beca fue aprobada. Debes revisar tu correo para ver los detalles de la solicitud o dirigirte a la dirección.
                </Col>
                <Col md={12} className="custom-mt-10">
                    <span className="text-danger" style={{fontSize: 10}}><i className="fa fa-check"></i>NO APROBADA</span>
                </Col>
                <Col md={12} style={{fontSize: 11}} align="justify">
                    Indica que tu petición fue rechazada, debes revisar tu correo para ver los motivos o dirigirte a dirección. En este momento puedes realizar otra solicitud de beca.
                </Col>
            </Row>
        </React.Fragment>
    )

    render() {
        let { status } = this.state;

        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col md={8}>
                            <div className={status.class} style={{padding:10}}>
                                <Row>
                                    <Col md={11}><div style={{fontSize:14}}>{status.text}</div></Col>
                                    <Col md={1}><i className={status.icon} style={status.styles}></i></Col>
                                </Row>
                            </div>
                            <Row className="custom-mt-10">
                                <Col md={12}>{this.contenido()}</Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <div style={{borderRadius: "4px 4px",}}>
                                <CustomCard
                                    styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                    title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                    category={<span style={{color: "#fff"}}>Beca Estudiantil</span>}
                                    color="#a80012"
                                    content={this.ayuda()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                {this.showModal()}
                {this.modalReport()}
            </React.Fragment>
        );
    }
}
 
export default BecaEst;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/BecaEst.jsx